import { Link } from 'react-router-dom';
import { FOOTER } from '@/constants/testIds';
import { PLATFORMS } from '@/lib/platforms';
import Logo from '@/components/Logo';

export const Footer = () => {
  return (
    <footer
      data-testid={FOOTER.root}
      className="border-t border-white/10 bg-ink-900"
    >
      <div className="px-6 md:px-12 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="mb-6">
              <Logo variant="amber" size={64} testId="footer-logo" />
            </div>
            <div className="mt-2 font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">
              themobilitygroup.co
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4">Platforms</div>
            <ul className="space-y-2 text-sm text-zinc-300">
              {PLATFORMS.map((p) => (
                <li key={p.slug}>
                  <a
                    href={p.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-amber transition-colors inline-flex items-center gap-1"
                  >
                    {p.name} ↗
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-4">Group</div>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li><Link to="/platforms" className="hover:text-amber transition-colors">Platforms</Link></li>
              <li><Link to="/solutions" className="hover:text-amber transition-colors">Solutions</Link></li>
              <li><Link to="/use-cases" className="hover:text-amber transition-colors">Use Cases</Link></li>
              <li><Link to="/investments" className="hover:text-amber transition-colors">Investments</Link></li>
              <li><Link to="/about" className="hover:text-amber transition-colors">About</Link></li>
              <li><Link to="/insights/two-wheeler-dealerships" className="hover:text-amber transition-colors">Insight · 2W OEMs</Link></li>
              <li><Link to="/contact" className="hover:text-amber transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-4">Connect</div>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li>
                <Link to="/contact" className="hover:text-amber transition-colors">
                  Partner With Us
                </Link>
              </li>
              <li>
                <Link to="/landscape" className="hover:text-amber transition-colors">
                  India Landscape
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">
            © {new Date().getFullYear()} The Mobility Group · All rights reserved
          </div>
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">
            Automotive · Mobility · Data · Capital
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
